<div class="delay-printing-container">
  <div class="dp-header flex_sb fw-700 lh-130">
    <div>
      {{ 'PRINTER_STATUS.DELAY_IN_ORDER_PRINTING' | fallbackTranslate }}
    </div>
    <div class="dialog-header-cross flex-center" (click)="cancelClicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>
  <div class="dp-body flex">
    <!--  show list of orders ( Left component) - start-->
    <div class="dp-left-container">
      <div class="ta_center">
        <img
          class="disconnect-img"
          [src]="images.PRINTER_LIST_ICON"
          alt="printer-list"
        />
      </div>
      <div class="printmiss__note br-4 flex p-4 gap-2 m-t-8">
        <img [src]="images?.YEL_INFO" class="img-24 m-t-2" alt="Note Icon"/>
        <p class="fw-400 m-b-0">{{ 'PRINTER_STATUS.PRINT_MISS_NOTE' | fallbackTranslate }}</p>
      </div>
      <div class="printer-list-container m-t-20">
        <ng-container *ngFor="let order of orderDataList; trackBy: trackOrder">
          <div
            class="printer-card flex c-pointer"
            [ngClass]="{
              'selected-order-card':
                order?.order_id === currPrinterCardData?.order_id,
              'all-events-printed':
                allEventsOfAOrderPrintedSuccessfully[
                  currPrinterCardData?.order_id
                ]
            }"
            (click)="orderCardClicked(order)"
          >
            <div class="info-icon">
              <img
                class="wd-100-hg-100"
                [src]="
                  allEventsOfAOrderPrintedSuccessfully[
                    currPrinterCardData?.order_id
                  ]
                    ? images.SUCCESS_PRINTER
                    : images.ERROR_PRINTER
                "
                alt="error-icon"
              />
            </div>
            <div class="order-details">
              <div class="order-name lh-100 fw-700 clr-333">
                <span> #{{ order?.order_seq }}</span>
                {{ order?.order_name ? order.order_name : 'Guest' }}
                {{ 'PRINTER_STATUS.S_ORDER' | fallbackTranslate }}
              </div>
              <div class="order-delay-desc clr-999 fw-400 lh-120 m-t-5">
                <span
                  *ngIf="
                    allEventsOfAOrderPrintedSuccessfully[
                      currPrinterCardData?.order_id
                    ];
                    else remainingDelayEvents
                  "
                >
                  {{
                    'PRINTER_STATUS.DELAY_IN_ORDER_PRINTING' | fallbackTranslate
                  }}
                </span>
                <ng-template #remainingDelayEvents>
                  {{ 'PRINTER_STATUS.DELAY_IN' | fallbackTranslate }}
                  {{ order?.order_delay_print_event_count }}
                  {{ 'PRINTER_STATUS.PRINT_EVENTS' | fallbackTranslate }}
                </ng-template>
              </div>
            </div>
            <div
              class="timing fw-400 lh-100 bg-fff"
              [class.success-green]="
                allEventsOfAOrderPrintedSuccessfully[
                  currPrinterCardData?.order_id
                ]
              "
            >
              {{ orderSince(order?.order_created_at) }}
              {{ 'PRINTER_STATUS.AGO' | fallbackTranslate }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <!--  show list of orders ( Left component) - Ends-->

    <!--  show list of batch daya ( right component) - start-->
    <div class="dp-right-container flex-1">
      <ng-container *ngFor="let batchData of currPrinterCardData?.itrData">
        <div class="batch fw-600 lh-140 clr-333">
          {{ 'PRINTER_STATUS.BATCH' | fallbackTranslate }} {{ batchData?.itr }}
        </div>
        <ng-container *ngFor="let itrEvent of batchData?.itr_events">
          <div class="right-side-actions-container flex_sb bg-fff">
            <div class="counter-name fw-600 lh-140 clr-333">
              {{ itrEvent?.counter_name }}
            </div>
            <div
              *ngIf="
                !checkIsAllEventsPrinted(itrEvent) &&
                !disconnectedPrinterIds.has(
                  itrEvent?.printer_events[0]?.event_data?.printing_id
                )
              "
              class="action-wrapper flex_sb"
            >
              <button
                class="btn-common left-btn lh-130 underline"
                (click)="printNotNeededClicked(itrEvent)"
              >
                {{ 'PRINTER_STATUS.PRINT_NOT_NEEDED' | fallbackTranslate }}
              </button>
              <button
                class="btn-common right-btn lh-130 color-white"
                (click)="printManuallyClicked(itrEvent)"
              >
                <img
                  class="m-r-5"
                  [src]="images.PRINTER_BTN_ICON"
                  alt="printer-icon"
                />
                <span class="underline">{{
                  'PRINTER_STATUS.PRINT_MANUALLY' | fallbackTranslate
                }}</span>
              </button>
            </div>

            <ng-container>
              <div
                class="action-wrapper flex_sb"
                *ngIf="checkIsAllEventsPrinted(itrEvent)"
              >
                <button class="success-btn lh-130">
                  {{ 'PRINTER_STATUS.PRINTING_SUCCESSFUL' | fallbackTranslate }}
                </button>
              </div>
            </ng-container>
            <div
              class="action-wrapper flex_sb"
              *ngIf="
                disconnectedPrinterIds.has(
                  itrEvent?.printer_events[0]?.event_data?.printing_id
                )
              "
            >
              <div class="flex align_center">
                <img
                  class="img-28 m-r-6"
                  [src]="images.PRINTER_STATUS_CONNECTION"
                  alt="printer-disconnected"
                />
                <div class="connection-error fw-400 lh-120">
                  {{ 'PRINTER_STATUS.PLEASE_CHECK' | fallbackTranslate }}
                  <br />
                  {{ 'PRINTER_STATUS.PRINTER_CONNECTION' | fallbackTranslate }}
                </div>
              </div>
              <button
                class="check-printer-connection lh-140 fw-600 underline"
                (click)="checkPrinterStatus()"
              >
                {{ 'PRINTER_STATUS.CHECK_PRINTER_STATUS' | fallbackTranslate }}
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <!--  show list of batch daya ( right component) - Ends-->
  </div>
</div>
